import * as React from "react";
import Documents from '../details/documents/Documents';
import History from '../details/history/History';
import NonprofitDetail from '../details/nonprofit/NonprofitDetail';

const BusinessAdminBig: React.FunctionComponent = () => (
    <section id="business-view-big">
        <div className="ms-Grid-col ms-md6 ms-lg3 ms-xl4">
            <NonprofitDetail />
        </div>
        <div className="ms-Grid-col ms-md6 ms-lg3 ms-xl4"><div className="tile-content"><Documents /></div></div>
        <div className="ms-Grid-col ms-md6 ms-lg3 ms-xl4"><div className="tile-content"><History /></div></div>
    </section >
);

export default BusinessAdminBig;